export function formatearNumero(numero: number) {
    return numero.toLocaleString("es-ES").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
